<template>
  <app-form
    ref="bootstrap_ref"
    class="bootstrap-form"
    default-label-width="120px"
    :form-data="form_config"
    :submit-request="onSubmit"
    :is-show-button="false"
    :form-props="{ inline: true }"
  >
    <template #custom="{ form_key }">
      <div v-if="form_key === 'action'">
        <el-button v-if="!is_show_reset_btn" type="primary" icon="el-icon-plus" size="mini" @click="confirm('confirm')">搭建广告</el-button>
        <el-button v-else icon="el-icon-refresh-right" size="mini" @click="onResetConfig">重置配置</el-button>
      </div>
      <div v-if="form_key === 'add_creative'">
        <el-button v-if="!is_show_reset_btn" type="primary" icon="el-icon-plus" size="mini" @click="confirm('add-creative')">添加创意</el-button>
      </div>
      <div v-if="form_key === 'template'">
        <el-button type="success" size="mini" @click="confirm('template')">读取模板</el-button>
      </div>
    </template>
  </app-form>
</template>

<script>
import { clone } from '@/utils';
import { getMediasListApi } from '@/api/medias';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

export default {
  components: {
    'app-form': () => import('@/components/app-form'),
  },
  mixins: [data_sharing_mixin],
  data() {
    return {
      form_config: require('./model/form-config')(this),
      button_type: 'confirm',
    };
  },
  computed: {
    // 是否显示重置按钮
    is_show_reset_btn() {
      return !!this.local_sharing_data.getFormContext();
    },
  },
  watch: {
    is_show_reset_btn() {
      this.setFormConfigDisabled();
    },
  },
  methods: {
    /**
     * 表单提交参数
     * @param {Object} params
     */
    onSubmit(params) {
      const { advertiser_ids } = this.form_config;
      const payload = clone({
        init_ops: params,
        advertiser_options: advertiser_ids.options,
      });
      this.$emit(this.button_type, payload);
    },

    /**
     * 确认
     * @returns {void}
     */
    confirm(button_type) {
      this.button_type = button_type;
      this.$refs.bootstrap_ref.confirm();
    },

    /**
     * 获取广告主账号列表
     */
    getAdvertiserList(params) {
      return new Promise((resolve, reject) => {
        getMediasListApi(params).then((response) => {
          const result = response.list.map(({ advertiser_id, advertiser_name, note }) => {
            return {
              label: `${advertiser_id}（${advertiser_name}）${note ? ' - ' + note : ''}`,
              value: advertiser_id,
            };
          });
          resolve(result);
        }).catch(reject);
      });
    },

    /**
     * 监听媒体平台改变
     * @param {string} type 媒体平台标识
     */
    async onChannelChange(type) {
      const params = { type, is_list: true };
      const { advertiser_ids, add_creative } = this.form_config;
      const is_support_channel = [CHANNEL_INTERFACE_TYPE.GDT, CHANNEL_INTERFACE_TYPE.JRTT, CHANNEL_INTERFACE_TYPE.BILIBILI, CHANNEL_INTERFACE_TYPE.BAIDU].includes(type);
      add_creative.hidden = !is_support_channel;

      const ret = await this.getAdvertiserList(params);
      advertiser_ids.value.splice(0);
      advertiser_ids.options = ret;
    },

    /**
     * 重置配置
     */
    onResetConfig() {
      this.$confirm('是否重置当前已配置的数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$emit('reset');
      });
    },

    /**
     * 设置表单禁用属性
     */
    setFormConfigDisabled() {
      const { channel_interface, advertiser_ids, ad_type } = this.form_config;
      [channel_interface, advertiser_ids, ad_type].forEach(form_config => {
        form_config.props.disabled = this.is_show_reset_btn;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bootstrap-form {
  /deep/.el-form {
    padding-bottom: 20px !important;
    .el-form-item:first-of-type {
      .el-form-item__label {
        width: 78px !important;
      }
    }
  }
}
</style>

<style lang="scss">
.fusion-loading-mask .el-icon-loading {
  font-size: 32px;
  margin-bottom: 15px;
}
</style>
